import React, { useState } from 'react';
import Header from './components/Header/Header';
import About from './components/About/About';
import InputForm from './components/InputForm/InputForm';
import Output from './components/Output/Output';
import './App.css';

function App() {
    const [activeTab, setActiveTab] = useState('About');
    const [resultData, setResultData] = useState(null); // TODO: resultDataはOutputタブ用
    const [appMessages, setAppMessages] = useState([]);
    const [appErrors, setAppErrors] = useState([]);
    const [isAppProcessing, setIsAppProcessing] = useState(false);

    // InputFormから解析完了を通知されるコールバック
    const handleAnalysisComplete = (result) => {
        setResultData(result);
        if (result) {
            setActiveTab('Output');
        }
    };

    const handleStatusUpdate = (type, message) => {
        setAppMessages([{ type, text: message }]);
        setAppErrors([]);
    };

    const handleErrorsUpdate = (errors) => {
        setAppErrors(errors);
        setAppMessages([]);
    };

    const handleProcessingChange = (processingStatus) => {
        setIsAppProcessing(processingStatus);
    };

    return (
        <div className="App">
            <section className="main">
                <Header />

                <div className="tabs">
                    <button onClick={() => setActiveTab('About')} className={activeTab === 'About' ? 'active' : ''}>
                        About
                    </button>
                    <button onClick={() => setActiveTab('Input')} className={activeTab === 'Input' ? 'active' : ''}>
                        Input parameters
                    </button>
                    <button onClick={() => setActiveTab('Output')} className={activeTab === 'Output' ? 'active' : ''}>
                        Output
                    </button>
                </div>

                <div className="app-messages">
                    {appMessages.map((msg, index) => (
                        <p key={index} className={msg.type}>{msg.text}</p>
                    ))}
                    {appErrors.map((error, index) => (
                        <p key={index} className="error">{error}</p>
                    ))}
                </div>

                {isAppProcessing && (
                    <div className="loading-overlay">
                        <div className="loading-spinner"></div>
                        <p>Processing request...</p>
                    </div>
                )}

                <div className="tab-content">
                    {activeTab === 'About' && <About />}
                    {activeTab === 'Input' && (
                        <InputForm
                            onAnalysisComplete={handleAnalysisComplete}
                            onStatusUpdate={handleStatusUpdate}
                            onErrorsUpdate={handleErrorsUpdate}
                            onProcessingChange={handleProcessingChange}
                        />
                    )}
                    {activeTab === 'Output' && <Output analysisData={resultData} />}
                </div>
            </section>
        </div>
    );
}

export default App;
